// Server values
export const SERVER_VALUE_YES = 'Y';
export const SERVER_VALUE_NO = 'N';
export const SERVER_VALUE_YES_LOWERCASE = 'y';
export const SERVER_VALUE_NO_LOWERCASE = 'n';

// HTTP constants
export const HTTP_METHOD_PATCH = 'PATCH';
export const HTTP_METHOD_POST = 'POST';
export const CHEMO_RECORDS_ENDPOINT = '/api/chemo/records';
export const SEND_CUSTOMER_MESSAGE_ENDPOINT = '/api/chemo/send-customer-message';

// String constants
export const EMPTY_STRING = '';
export const ERROR_SPLIT_DELIMITER = '2';
export const FINISHED_STATUS_HEB = 'סיים';
export const COUNT_PLACEHOLDER = '{count}';
export const DASH_PLACEHOLDER = '-';
export const CHECK_MARK = '✓';

// Date constants
export const ISO_DATE_SEPARATOR = 'T';
export const DATE_REGEX_ISO = /^\d{4}-\d{2}-\d{2}$/;
export const DATE_REGEX_ISO_PREFIX = /^(\d{4}-\d{2}-\d{2})/;
export const PAD_LENGTH = 2;
export const PAD_CHAR = '0';
export const HOUR_ZERO = 0;
export const MINUTE_ZERO = 0;
export const SECOND_ZERO = 0;
export const MILLISECOND_ZERO = 0;
export const MONTH_OFFSET = 1;
export const DATE_PART_INDEX = 0;

// Field names
export const FIELD_NAMES = {
    APPROVED: 'APPROVED',
    NOT_APPROVED: 'NOTAPPROVED',
    FINISH: 'FINISH',
    TO_DUE_DATE: 'TODUEDATE',
    ROW_ID: 'KLINE2',
    KLINE: 'KLINE',
    LOADED: 'LOADED',
    DUEDATE1: 'DUEDATE1',
    DUEDATE: 'DUEDATE',
    SPECVALUE: 'SPECVALUE',
    FROMDATE: 'FROMDATE',
    TODATE: 'TODATE',
    SNAME: 'SNAME',
    SUBFORM: 'NEO_PARTDUEDATE_LINE_SUBFORM',
    DAY: 'DAY',
    CUSTDES: 'CUSTDES',
    CUSTNAME: 'CUSTNAME',
    CDES: 'CDES',
    ORDNAME: 'ORDNAME',
    ORDBAL: 'ORDBAL',
    ORDI1: 'ORDI1'
};

// Top records select options
export const TOP_RECORDS_OPTIONS = [5, 8, 12];
